// import Vue from 'vue'
// import App from './App.vue'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Antd from 'ant-design-vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import VueShowdown from 'vue-showdown'
import 'ant-design-vue/dist/antd.css'

Vue.config.productionTip = false

Vue.use(VueI18n);
Vue.use(Antd);
// Vue.use() 的第二个参数是可选的
Vue.use(VueShowdown, {
  // 设置 showdown 默认 flavor
  flavor: 'github',
  // 设置 showdown 默认 options （会覆盖上面 flavor 的 options）
  options: {
    emoji: true,
  },
})

const i18n = new VueI18n({
    locale: window.localStorage['lang'] || 'en-US',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
      'zh-CN': require('./intl/zh'),   // 中文语言包
      'en-US': require('./intl/en')    // 英文语言包
    }
})

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   i18n,
//   router,
//   components: { App },
//   template: '<App/>'
// })

// Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
